export default {
  auth: {
    loginTitle: 'Selamat datang kembali',
    loginSubtitle: 'Masuk untuk melanjutkan menonton.',
    registerTitle: 'Buat akun',
    registerSubtitle: 'Daftar dengan nomor HP atau email untuk mulai menonton.',
    account: 'Akun',
    accountPlaceholder: 'Masukkan nomor HP atau email',
    phoneTab: 'Nomor HP',
    emailTab: 'Email',
    phone: 'Nomor HP',
    phonePlaceholder: 'Masukkan nomor HP',
    email: 'Email',
    emailPlaceholder: 'Masukkan email',
    nickname: 'Nama',
    nicknamePlaceholder: 'Masukkan nama',
    password: 'Kata sandi',
    passwordPlaceholder: 'Masukkan kata sandi',
    repassword: 'Konfirmasi',
    repasswordPlaceholder: 'Ulangi kata sandi',
    loginAction: 'Masuk',
    loginLoading: 'Sedang masuk...',
    registerAction: 'Daftar',
    agreementPrefix: 'Saya sudah membaca dan setuju dengan',
    noAccount: 'Belum punya akun?',
    hasAccount: 'Sudah punya akun?',
    goRegister: 'Daftar',
    goLogin: 'Masuk',
    agreementRequired: 'Setujui ketentuan terlebih dahulu',
    accountRequired: 'Masukkan akun',
    passwordRequired: 'Masukkan kata sandi',
    invalidPhone: 'Nomor HP tidak valid',
    invalidEmail: 'Email tidak valid',
    invalidNickname: 'Nama minimal 2 karakter',
    invalidPassword: 'Kata sandi minimal 6 karakter',
    passwordMismatch: 'Kata sandi tidak sama',
    registerReady: 'Data pendaftaran sudah lengkap',
    registerSuccess: 'Pendaftaran berhasil',
    registerFailed: 'Akun sudah ada atau formatnya tidak valid'
  },
  settings: {
    title: 'Pengaturan',
    editProfile: 'Edit Profil',
    editProfileDesc: 'Ubah nama dan info profil',
    changePassword: 'Ubah Kata Sandi',
    changePasswordDesc: 'Jaga keamanan akun Anda',
    logout: 'Keluar',
    logoutDesc: 'Keluar dari perangkat ini',
    logoutConfirmTitle: 'Keluar?',
    logoutConfirmMessage: 'Anda perlu masuk lagi untuk memakai akun ini.',
    logoutConfirmAction: 'Keluar',
    logoutSuccess: 'Berhasil keluar',
    cancel: 'Batal',
    uploadAvatar: 'Unggah',
    uploading: 'Mengunggah...',
    uploadSuccess: 'Avatar berhasil diunggah',
    uploadFailed: 'Gagal mengunggah avatar',
    invalidAvatar: 'Pilih file gambar',
    save: 'Simpan',
    saving: 'Menyimpan...',
    profileEmpty: 'Masukkan nama atau unggah avatar',
    invalidNickname: 'Nama minimal 2 karakter',
    profileUpdateSuccess: 'Profil diperbarui',
    profileUpdateFailed: 'Gagal memperbarui profil',
    oldPassword: 'Saat ini',
    oldPasswordPlaceholder: 'Kata sandi saat ini',
    newPassword: 'Baru',
    newPasswordPlaceholder: 'Kata sandi baru',
    confirmPassword: 'Konfirmasi',
    confirmPasswordPlaceholder: 'Ulangi kata sandi',
    passwordRequired: 'Masukkan kata sandi baru',
    passwordUpdateSuccess: 'Kata sandi diperbarui',
    passwordUpdateFailed: 'Gagal memperbarui kata sandi'
  },
  common: {
    back: 'Kembali'
  },
  login: {
    submitText: 'Masuk Sekali Ketuk',
    errorAccount: 'Akun atau kata sandi salah'
  },
  legal: {
    and: 'dan',
    suffix: 'setujui untuk melanjutkan',
    policy: 'Kebijakan Privasi',
    terms: 'Syarat Layanan'
  },
  favorite: {
    empty: 'Belum ada favorit'
  },
  history: {
    continue: 'Lanjut nonton',
    watched: 'Riwayat Nonton',
    empty: 'Belum ada tontonan',
    ongoing: 'Berjalan',
    completed: 'Tamat',
    loading: 'Memuat...',
    noMore: 'Tidak ada lagi',
    loadMore: 'Muat lagi'
  },
  profile: {
    loginTitle: 'Silakan masuk',
    loginDesc: 'Akses favorit dan riwayat tontonan',
    loginBtn: 'Masuk',
    guest: 'Tamu',
    userId: 'ID',
    balance: 'Lihat saldo',
    pointsBalance: 'Saldo',
    memberBadge: 'Member',
    recharge: 'Deposito',
    subscriptionTitle: 'Langganan',
    subscriptionDesc: 'Lihat paket hemat untuk nonton',
    subscriptionBtn: 'Lihat',
    logout: 'Keluar',
    menu: {
      recharge: 'Deposito',
      favorite: 'Favorit Saya',
      history: 'Riwayat Nonton',
      rechargeHistory: 'Riwayat Deposito',
      contact: 'Hubungi Kami'
    },
    contact: {
      support: 'Bantuan Pelanggan'
    }
  },
  video: {
    totalEpisodes: 'Semua {num} episode',
    myPage: 'Profil',
    favorite: 'Favorit',
    episodes: 'Episode',

    playingEpisode: 'Memutar Episode {num}',
    episodeUnit: 'Ep {num}',

    buyTitle: 'Beli',
    buySubtitle: 'Pilih cara untuk lanjut',

    buySingle: 'Beli Episode',
    buySingleDesc: 'Tonton episode ini saja',

    buyAll: 'Beli Semua',
    buyAllDesc: 'Buka semua episode',
    unlockPrice: 'Harga:',
    episodeShort: 'episode',
    unlockNextEpisodes: '{count} episode berikutnya',
    unlockRemainingEpisodes: 'Buka sisa episode',
    unlockAllEpisodes: 'Buka semua',
    upgradeSubscription: 'Upgrade Langganan',
    myBalance: 'Saldo saya',
    rechargeNow: 'Deposito',
    chooseSubscriptionPackage: 'Pilih paket langganan',
    balancePurchase: 'Beli dengan saldo',
    subscriptionPrivilege: 'Paket benefit langganan',
    unlockCost: 'Harga buka',
    popular: 'Populer',
    pass: 'Pass',
    days: 'Hari',
    subscriptionTitle: 'Langganan',
    subscriptionHint: 'Geser ke samping',
    subscriptionDefault: 'Rekomendasi',
    subscriptionDays: '{days} hari',
    subscriptionAction: 'Pilih paket ini',
    subscriptionUnavailable: 'Langganan belum tersedia',
    createSubscriptionOrderFail: 'Gagal membuat pesanan langganan',
    subscriptionSuccess: 'Langganan berhasil',
    subscriptionCancel: 'Langganan dibatalkan',
    billingWeekly: 'Mingguan',
    billingMonthly: 'Bulanan',
    billingHalfYearly: '6 Bulan',
    billingYearly: 'Tahunan',

    loading: 'Memuat...',

    noDataError: 'Data episode bermasalah',

    createOrderFail: 'Gagal membuat pesanan',
    missingOrderId: 'trade_order_id tidak ada',

    insufficientBalance: 'Saldo tidak cukup. Lakukan deposito terlebih dahulu.',

    paying: 'Memproses pembayaran...',
    payCancel: 'Pembayaran dibatalkan',

    rechargeSuccess: 'Deposito berhasil',
    rechargeFail: 'Deposito gagal atau dibatalkan',
    orderCheckFail: 'Gagal cek pesanan',
    buySuccess: 'Pembelian berhasil',
    unlockSuccess: 'Berhasil dibuka',
    payFail: 'Pembayaran gagal',
    payProcessing: 'Pembayaran diproses. Cek lagi nanti'
  },
  recharge: {
    currency: 'Rp',
    title: 'Deposito',

    selectAmount: 'Pilih nominal',

    noticeTitle: 'Catatan Penting',

    notice1: '※ Poin adalah produk digital dan langsung bisa dipakai setelah dibeli.',
    notice2: '※ 1 Bean = 1 koin.',
    notice3: '※ Poin, bonus poin, dan benefit VIP adalah produk digital.',
    notice4: '※ Jika refund diproses, akses tontonan yang dibeli akan dicabut sesuai jumlah refund.',
    notice5: '※ Jika refund sebagian, hanya akses yang sesuai nilai refund yang dicabut.',
    notice6: '※ Sisa poin, poin terpakai, bonus, dan akses yang dicabut mengikuti aturan refund platform.',
    btn: 'Deposito',
    success: 'Pembayaran berhasil',

    footnote: '※ Poin langsung masuk setelah pembayaran.',

    createOrderFail: 'Gagal membuat pesanan',
    rechargeError: 'Deposito gagal',
    processing: 'Pembayaran diproses',
    cancelled: 'Pembayaran dibatalkan'
  },
  subscription: {
    title: 'Langganan',
    loading: 'Memuat...',
    empty: 'Belum ada paket',
    loadFail: 'Gagal memuat paket',
    processing: 'Memproses...',
    selectPlan: 'Pilih paket terlebih dahulu',
    currentSubscription: 'Langganan Saat Ini',
    current: 'Aktif',
    status: 'Status',
    validUntil: 'Aktif sampai',
    nextRenewal: 'Perpanjangan berikutnya',
    statusActive: 'Aktif',
    statusCancelledValid: 'Dibatalkan, masih aktif sampai habis',
    statusInactive: 'Tidak aktif',
    reactivate: 'Aktifkan Lagi',
    upgrade: 'Ganti Paket',
    unavailable: 'Langganan belum tersedia',
    currentPlan: 'Paket Saat Ini',
    currentPlanToast: 'Ini paket yang sedang digunakan',
    changeTip: 'Anda memiliki langganan aktif. Anda dapat beralih ke paket lain.',
    reactivateTip: 'Langganan sudah dibatalkan, tetapi masih aktif. Perpanjangan otomatis dapat diaktifkan kembali.',
    blockingTip: 'Anda sudah memiliki langganan. Paket baru dapat dibeli setelah masa aktif berakhir.',
    cannotReactivate: 'Langganan ini tidak bisa diaktifkan lagi',
    cannotChange: 'Paket belum bisa diganti sekarang'
  },
  checkout: {
    title: 'Pembayaran',
    qrisStandard: 'Standar Indonesia',
    qrisPay: 'Pembayaran QRIS',
    qrisHint: 'Pindai dengan aplikasi bank atau e-wallet yang mendukung QRIS.',
    scanTitle: 'Pindai untuk bayar',
    scanDesc: 'Gunakan aplikasi pembayaran untuk memindai kode QR dan menyelesaikan pembayaran.',
    qrAlt: 'Kode QR pembayaran',
    qrUnavailable: 'Kode QR tidak tersedia',
    waiting: 'Menunggu pembayaran',
    paid: 'Pembayaran berhasil',
    orderNo: 'No. Pesanan',
    cancelPayment: 'Batalkan pembayaran',
    cancelled: 'Pembayaran dibatalkan'
  },
  category: {
    title: 'Kategori',
    noData: 'Tidak ada data',
    loadFail: 'Gagal memuat kategori'
  },
  orderHistory: {
    title: 'Riwayat Pesanan',
    empty: 'Belum ada pesanan',
    orderNo: 'No. Pesanan',
    amount: 'Jumlah',
    status: 'Status',
    time: 'Tanggal',
    loading: 'Memuat...',
    loadEnd: 'Semua sudah dimuat',
    currency: 'JPY',
    statusMap: {
      completed: 'Selesai',
      pending: 'Menunggu',
      cancelled: 'Dibatalkan',
      failed: 'Gagal'
    },
    productName: 'Produk',
    unitCoin: 'Koin'
  },
  tab: {
    home: 'Beranda',
    category: 'Kategori',
    profile: 'Profil'
  },
  banner: {
    hotDramaTitle: 'Drama Populer',
    title: 'Semua Drama Pendek',
    menu: 'Menu'
  },
  search: {
    searchBtn: 'Cari',
    pageTitle: 'Cari',
    placeholder: 'Masukkan kata kunci',
    placeInputHolder: 'Cari judul atau aktor',
    popularSearch: 'Populer',
    recentSearch: 'Terakhir',
    noHistory: 'Belum ada riwayat',
    searchResultOf: 'Hasil untuk',
    countUnit: 'item',
    noWorks: 'Tidak ada hasil',
    tags: {
      romance: 'Romantis',
      suspense: 'Suspense',
      comedy: 'Komedi',
      action: 'Aksi',
      fantasy: 'Fantasi',
      historical: 'Sejarah',
      youth: 'Remaja',
      family: 'Keluarga',
      revenge: 'Balas Dendam',
      business: 'Bisnis',
      urban: 'Kota',
      campus: 'Kampus',
      marriage: 'Pernikahan',
      sweet: 'Manis',
      sad: 'Sedih',
      inspirational: 'Inspiratif',
      mystery: 'Misteri',
      crime: 'Kriminal',
      thriller: 'Thriller',
      completed: 'Tamat',
      ongoing: 'Berjalan',
      new: 'Baru'
    }
  },
  privacy: {
    title: 'Kebijakan Privasi',
    backLabel: 'Kembali',
    section1: {
      title: '1. Ringkasan',
      content: 'Kebijakan ini menjelaskan cara OttDrama mengelola data pengguna. Kami mengikuti aturan yang berlaku dan menjaga data pribadi dengan baik.'
    },
    section2: {
      title: '2. Data yang Kami Kumpulkan',
      intro: 'Kami dapat mengumpulkan data berikut:',
      items: [
        'Info akun seperti email dan nama pengguna',
        'Data penggunaan seperti riwayat nonton, pencarian, dan favorit',
        'Info perangkat seperti OS, model, dan versi aplikasi',
        'Data teknis seperti IP, cookie, dan ID iklan',
        'Isi dan riwayat kontak dukungan'
      ]
    },
    section3: {
      title: '3. Tujuan Penggunaan',
      intro: 'Data digunakan untuk:',
      items: [
        'Menyediakan dan meningkatkan layanan',
        'Membantu pengguna',
        'Menjaga keamanan',
        'Menganalisis penggunaan',
        'Mengenalkan fitur baru',
        'Memenuhi kewajiban hukum'
      ]
    },
    section4: {
      title: '4. Pembayaran',
      para1: 'Kami dapat memakai platform seperti Apple App Store atau Google Play.',
      para2: 'Kami tidak menyimpan detail pembayaran. Data tersebut dikelola oleh platform terkait.'
    },
    section5: {
      title: '5. Pihak Ketiga',
      intro: 'Kami tidak membagikan data, kecuali:',
      items: [
        'Dengan persetujuan Anda',
        'Jika diwajibkan hukum',
        'Untuk melindungi keselamatan atau aset',
        'Untuk kepentingan kesehatan publik atau perlindungan anak'
      ]
    },
    section6: {
      title: '6. Layanan Eksternal',
      intro: 'Kami dapat memakai:',
      items: [
        'Alat analitik',
        'Layanan iklan',
        'Alat laporan crash'
      ],
      additionalNote: 'Layanan tersebut dapat mengumpulkan data anonim.'
    },
    section7: {
      title: '7. Cookie',
      para1: 'Kami memakai cookie untuk memperbaiki pengalaman dan menganalisis penggunaan.',
      para2: 'Anda dapat menonaktifkan cookie, tetapi beberapa fitur mungkin tidak berjalan.'
    },
    section8: {
      title: '8. Keamanan Data',
      content: 'Kami menerapkan langkah yang wajar untuk melindungi data Anda.'
    },
    section9: {
      title: '9. Hak Pengguna',
      para1: 'Anda dapat meminta akses, koreksi, atau penghapusan data.',
      para2: 'Hubungi kami untuk permintaan tersebut.'
    },
    section10: {
      title: '10. Pengguna di Bawah Umur',
      content: 'Pengguna di bawah umur perlu izin wali.'
    },
    section11: {
      title: '11. Perubahan',
      content: 'Kami dapat memperbarui kebijakan ini kapan saja.'
    },
    section12: {
      title: '12. Kontak',
      contactLine1: 'Untuk pertanyaan:',
      contactLine2: 'Email: duanjushortvideotv@gmail.com'
    },
    effectiveDate: 'Berlaku sejak: 1 Jan 2026'
  },
  agreement: {
    title: 'Syarat Layanan',
    backLabel: 'Kembali',
    section1: {
      title: '1. Ruang Lingkup',
      content: 'Syarat ini berlaku untuk OttDrama. Dengan menggunakan layanan ini, Anda menyetujui syarat ini.'
    },
    section2: {
      title: '2. Pendaftaran',
      para1: 'Pengguna harus mendaftar dengan data yang benar.',
      para2: 'Kami dapat menolak pendaftaran jika:',
      items: [
        'Data palsu',
        'Pernah melanggar aturan',
        'Ada alasan lain yang perlu dipertimbangkan'
      ]
    },
    section3: {
      title: '3. Akun',
      para1: 'Anda bertanggung jawab atas akun Anda.',
      para2: 'Kami tidak bertanggung jawab atas penyalahgunaan akun.'
    },
    section4: {
      title: '4. Layanan',
      content: 'Kami menyediakan drama pendek dan dapat memperbarui fitur kapan saja.'
    },
    section5: {
      title: '5. Konten Berbayar',
      para1: 'Sebagian konten berbayar.',
      para2: 'Harga dan ketentuan ditampilkan di aplikasi.'
    },
    section6: {
      title: '6. Poin',
      para1: 'Poin dapat dipakai untuk pembelian.',
      items: [
        'Hanya bisa dipakai di aplikasi',
        'Tidak bisa ditukar uang tunai',
        'Tidak bisa refund kecuali diwajibkan hukum',
        'Dapat memiliki masa berlaku'
      ]
    },
    section7: {
      title: '7. Pembayaran',
      para1: 'Pembayaran diproses oleh platform seperti Apple atau Google.',
      para2: 'Tidak ada refund setelah pembelian kecuali diwajibkan hukum.'
    },
    section8: {
      title: '8. Larangan',
      intro: 'Jangan melakukan hal berikut:',
      items: [
        'Melanggar hukum',
        'Terlibat tindakan kriminal',
        'Melanggar hak pihak lain',
        'Mengganggu layanan',
        'Memakai layanan untuk penyalahgunaan',
        'Mengumpulkan data pengguna',
        'Menyamar sebagai orang lain',
        'Meretas atau mencoba akses ilegal',
        'Menyalin atau menyebarkan konten',
        'Mengganggu operasional',
        'Tindakan lain yang tidak pantas'
      ]
    },
    section9: {
      title: '9. Hak Kekayaan Intelektual',
      para1: 'Semua konten milik kami atau pemberi lisensi.',
      para2: 'Tidak boleh digunakan tanpa izin.'
    },
    section10: {
      title: '10. Penangguhan',
      intro: 'Kami dapat menangguhkan akun jika:',
      items: [
        'Melanggar syarat',
        'Memberi data palsu',
        'Gagal membayar',
        'Ada risiko lain'
      ]
    },
    section11: {
      title: '11. Pengguna di Bawah Umur',
      content: 'Pengguna di bawah umur perlu izin wali.'
    },
    section12: {
      title: '12. Gangguan Layanan',
      intro: 'Layanan dapat berhenti karena:',
      items: [
        'Pemeliharaan',
        'Bencana',
        'Gangguan sistem',
        'Alasan lain'
      ]
    },
    section13: {
      title: '13. Penafian',
      para1: 'Kami tidak menjamin layanan selalu bebas error.',
      para2: 'Kami tidak bertanggung jawab kecuali karena kelalaian berat.'
    },
    section14: {
      title: '14. Perubahan',
      content: 'Kami dapat memperbarui syarat ini kapan saja.'
    },
    section15: {
      title: '15. Privasi',
      content: 'Data dikelola sesuai Kebijakan Privasi.'
    },
    section16: {
      title: '16. Hukum',
      content: 'Hukum Jepang berlaku.'
    },
    section17: {
      title: '17. Kontak',
      contactLine1: 'Untuk pertanyaan:',
      contactLine2: 'Email: duanjushortvideotv@gmail.com',
      contactLine3: 'Jam: Hari kerja 10:00-17:00'
    }
  },
  contact: {
    greeting: 'Hubungi Kami',
    subGreeting: 'Bantuan & pertanyaan',
    email: 'Email',
    whatsapp: 'WhatsApp',
    line: 'LINE',
    copyHint: 'ketuk untuk salin',
    copy: 'Salin',
    message: 'Pesan',
    addFriend: 'Tambah Teman',
    noteEmail: 'Hubungi kami di sini',
    noteWhatsapp: 'Jam kerja: 10:00-18:00',
    noteLine: 'Akun resmi',
    footerNote: '* Kami biasanya membalas dalam 24 jam.\n* Sertakan info yang diperlukan saat menghubungi kami.',
    toastCopySuccess: 'Disalin',
    toastCopyEmail: 'Alamat email',
    toastCopyWhatsapp: 'Nomor WhatsApp',
    toastCopyLine: 'LINE ID',
    toastShareSuccess: 'Berhasil dibagikan',
    toastShareFail: 'Gagal dibagikan'
  }
}
